<input
  class="form-checkbox__input"
  type="checkbox"
  [id]="inputUid"
  [attr.name]="name"
  [required]="required"
  [attr.checked]="checked"
  [attr.tabindex]="tabindex"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel"
  (change)="onChange()"
  data-test="input-checkbox"
/>
<label
  [for]="inputUid"
  class="form-checkbox {{ inputState }}"
  data-test="label-checkbox"
>
  <div
    class="form-checkbox__label"
    [class.form-checkbox--top]="align === 'top'"
    [class.form-checkbox--bottom]="align === 'bottom'"
  >
    <app-icon
      class="form-checkbox__icon"
      [name]="iconName"
      [style]="iconStyle"
    ></app-icon>
    <ng-container *ngIf="label">
      <div [innerHTML]="label" class="form-checkbox__link"></div>
    </ng-container>
    <ng-container *ngIf="!label">
      <ng-content></ng-content>
    </ng-container>
  </div>
  <p
    class="form-checkbox-description"
    *ngIf="description"
    [innerText]="description"
  ></p>
</label>
